<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
  <video-view  :setting="cameraSetting" :camera="cameraCode" :active="activeVideo"  @closeVideView="closeVideView"/>

     <!-- <vs-popup title="" :active.sync="popupActive">
    <div id="page-camera-view" >
     <iframe width="640px" height="480px" :src="reset" frameborder="0" allowfullscreen></iframe>
  </div>
      </vs-popup> -->
  <!-- <div v-if="reset" style="z-index:99990; width:100%; height:100%; position:fixed; background-color: rgba(0,0,0,0.5); top:0; left:0">
  <div  :style="videoSetting" style="margin:auto; position:absolute; left:0; right:0; top:0; bottom:0; z-index:1 ;background-color: #F8F8F8">
    <iframe :style="videoSetting" :src="reset" frameborder="0" allowfullscreen></iframe>
    <i  @click="popupActive = false" class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="position:absolute; top:0 right:0; z-index:2; margin-left:-40px">close</i>
  </div>
  </div> -->

    <!-- <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination
              search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

        </div> -->

        <!-- ITEMS PER PAGE -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ students.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : students.length }} of {{ queriedStudents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div> -->
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <!-- <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead" >
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="popularity">Camera(s)</vs-th>
      </template>

      <template slot-scope="{data}" >
        <tbody >
        <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="img-container">
            <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full shadow-md studentdot mr-2"/>
            <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent="tr.fname[0].toUpperCase()"></p>
          </vs-td>
          <vs-td>
            <p v-if="lng === 'dogs'" class="product-name font-medium truncate flex">{{tr.fname}}</p>
            <p v-else class="product-name font-medium truncate">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
            <span class="flex items-center" @click="MessagePopupAction(tr)">
                  <feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Message</span>
                </span>
          </vs-td>
          <vs-td>
            <vx-tooltip style="display: inline-block" v-for="item in tr.cameras" :key="item.id" :text="item.name"
                        position="top">
              <router-link :to="{ path: '/students/cameras/'+ encrptId + item.id + encrptId}"
                           class="text-inherit underline"><p :style="{background: item.color_code}"
                                                             class="w-4 h-4 round" style="float: left"></p>
              </router-link>
            </vx-tooltip>

          </vs-td>
            </vs-tr>
        </tbody>
      </template>
    </vs-table> -->
    <div id="demo-basic-card" v-if="camerasLength > 0">

        <div class="vx-row">
            
              <div class="vx-col w-full sm:w-1/4 lg:w-1/6 mb-base" :key="indextr" v-for="(tr, indextr) in filteredStudentList">
                <!-- <router-link :to="{ path: '/students/cameras/'+ encrptId + tr.id + encrptId}" class="text-inherit"> -->
                <!-- <router-link :to="{ path: '/students/cameras/'+ tr.code}" class="text-inherit"> -->
<!-- {{tr}} -->
                <vx-card class="p-2 cursor-pointer" @click="PlayCamera(tr.id,tr.code,tr.location_setting.location_camera_setting,tr.location_setting.id)">
                    <!-- <vs-avatar class="mx-auto mb-6 block" size="80px" v-if="tr.image" :src="img_cdn+tr.image" /> -->
                     <!-- <vs-avatar class="mx-auto mb-6 block" size="80px" /> -->
                    <p :style="{background: tr.color_code}" id="circle"></p>
                    <div class="text-center truncate">
                       <h4 class="mb-1 mt-5">{{tr.name}}</h4>
                   
                      <!-- <p class="text-grey" @click="MessagePopupAction(tr)" style="cursor:pointer"><feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4"/>Messages</p> -->
                    </div>
                     <!-- <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                      <vs-row>
                        <vs-col  vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
                            <span>
                            <p class="text-xl">Cameras</p>
                            <p v-if="tr.cameras.length === 0" class="text-grey">No camera</p>
                            <vx-tooltip v-else style="display: inline-block" v-for="item in tr.cameras" :key="item.id" :text="item.name" position="top">
                              <router-link :to="{ path: '/students/cameras/'+ encrptId + item.id + encrptId}" class="text-inherit underline"><p :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></p></router-link>
                             </vx-tooltip>
                           </span>
                         </vs-col>
                       </vs-row>
                    </div> -->
                </vx-card>
                    <!-- </router-link> -->
            </div>
        </div>
    </div>
     <p v-else class="ml-5 text-left mt-5">No Cameras Found.</p>
    <div class="demo-alignment">
      <div class="fill-row-loading">
        <div
          :class="{ activeLoading: activeLoading }"
          :id="[`loading-sound`]"
          class="vs-con-loading__container loading-example"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VideoView from '../../components/VideoView.vue'
import {
  ALL_CAMERAS,
  ALL_LOCATIONS,
  DELETE_IMAGE,
  GET_USER_STUDENTS,
  REMOVE_STUDENT,
  UPDATE_STUDENT_STATUS,
  PLAY_CAMERA
} from '@/graphql'

export default {
  components: {
    moment,
    'video-view':VideoView
  },
  data () {
    return {
      encrptId: '',
      students: [],
      selected: [],
      cameras: [],
      locations: [],
      itemsPerPage: 4,
      isMounted: false,
      meID: '',
      meRole: '',
      lng:'',
      types: ['sound'],
      encrptId : '',
      students:[],
      selected:[],
      cameras:[],
      locations:[],
      itemsPerPage: 4,
      isMounted: false,
      meID:'',
      meRole:'',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      types:['sound'],
      popupActive: false,
      activeLoading: false,
      custom_search_filter: 'Search By Location',
      custom_search_filter_camera: 'Search By Camera',
      // products: [],

      // Data Sidebar
      addNewDataSidebar: false,
      addNewCamUserSidebar: false,
      addSettingSidebar: false,
      addPasswordSidebar: false,
      addScheduleSidebar: false,
      sidebarSettingData: {},
      sidebarData: {},
      camUserSidebarData: {},
      passwordSidebarData: {},
      scheduleData: {},
      Imgdlt: '',
      DeletedItem: '',
      currrent_schedule: {
        dates: {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
      },
      dataUserSchedule: {
        schedule: {
          scheduledates: {}
        }
      },
      current_schedule_dates: '',
      ddd: '',
      MessagePopup : false,
      messageSidebar: false,
      messageData:{},
      // IframeSrc:null,
      // video_setting:{width:'640', height:'360'},
      // videoSetting:{width:'640px', height:'360px'},
      StudentCam:0,
      cameraSetting:[],
      cameraCode:null,
      activeVideo:false
    }
  },
  watch:{
    // windowWidth(val){
    //   if(val < this.video_setting.width){
    //         const calc = val * 0.95
    //         this.videoSetting.width=calc+'px'
    //         // console.log("sw",val)
    //         // console.log("vw",this.video_setting.width)
    //         // console.log("sw/vs",val/this.video_setting.width)
    //         // console.log("sw/vs",val/this.video_setting.width)
    //         // console.log("sw/vs x vh",(val/this.video_setting.width) * this.video_setting.height)
    //         // console.log(val)
    //         const height = (calc / this.video_setting.width) * this.video_setting.height
    //         this.videoSetting.height = height+'px'
    //         console.log(this.videoSetting.height)
    //   }
    //   else{
    //       this.videoSetting.width=this.video_setting.width+'px'
    //       this.videoSetting.height=this.video_setting.height+'px'
    //   }  
    // }  
  },
  computed: {
     windowWidth (){ 
        return this.$store.state.windowWidth 
       },
     reset () {
      if (this.popupActive) {
        return this.IframeSrc
      }
      if (!this.popupActive) {
         return this.IframeSrc = null
      }
    },
    camerasLength(){
        return this.filteredStudentList.length
    }, 
    filteredStudentList () {
        var cameras = []
        this.students.forEach(element => {
          if(element.status){
            element.cameras.forEach(element => {
                cameras.push(element)
            });
          }
        });
      var unique_cameras = cameras.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
      return unique_cameras
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length
    },

    locln () {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.students.length
    },
    select () {
      return this.selected.length
    }
  },
  methods: {
    // checkwindow(val){
    //   if(val < this.video_setting.width){
    //         const calc = val * 0.95
    //         this.videoSetting.width=calc+'px'
    //         const height = (calc / this.video_setting.width) * this.video_setting.height  
    //         this.videoSetting.height = height+'px'
    //         console.log(this.videoSetting.height)
    //   }
    //   else{
    //       this.videoSetting.width=this.video_setting.width+'px'
    //       this.videoSetting.height=this.video_setting.height+'px'
    //   }  
    // }, 
   PlayCamera (id,code,settings,location) {
      const camera = {id:id,code:code,location:location}
      this.cameraSetting=settings,
      this.cameraCode=camera
      this.activeVideo=true
    },
      closeVideView(){
      this.activeVideo=false
      this.cameraSetting=[]
      this.cameraCode={}
   },
    // PlayCamera(id,code){
    //  if(code){
    //      this.$router.push({path: '/students/cameras/'+ this.encrptId + id + this.encrptId})
    //  }
    //  else{
    //     this.$vs.notify({
    //     title: 'Camera',
    //     text:   'This camera is not configured yet.',
    //     color:  'danger',
    //     position: 'top-right'
    //   })
    //  }
    // },
    // MessagePopupAction(data){
    //   this.MessagePopup=true
    //   this.messageSidebar = !this.messageSidebar
    //   this.messageData = data
    // },
    MessagePopupAction (data) {
      const arr = this.students
      for (let i = 0; i < arr.length; i++) { if (arr[i].id === data.id) { arr.splice(i, 1); i-- } }
      arr.unshift(data)
      this.$store.dispatch('setStudent', arr)
      this.$router.push('/alerts')
    },
    // getStudentSchedule(id) {
    //   let student_schedule = [];
    //   for (let i = 0; i < this.students.length; i++) {
    //     if (this.students[i].id == id) {
    //       if (this.students[i].schedule) {
    //         for (
    //           let j = 0;
    //           j < this.students[i].schedule.scheduledates.length;
    //           j++
    //         ) {
    //           student_schedule.push(this.students[i].schedule.scheduledates[j]);
    //         }
    //         this.dataUserSchedule.schedule.scheduledates = student_schedule;
    //         this.getCurrentPeriod();
    //         this.CheckCondtion1(this.currrent_schedule.dates);
    //         this.MergeCurrentSlot(this.currrent_schedule.dates);
    //         let userMergedSlots = this.MergeUserScheduleSlots(
    //           this.dataUserSchedule
    //         );
    //         ////Condition 2: check each slot
    //         let condition2 = true;
    //         let totalCurrentSlotSlots = 0;
    //         let validCurrentSlots = 0;
    //         for (let day in this.current_schedule_dates) {
    //           for (let j in this.current_schedule_dates[day]) {
    //             if (
    //               this.current_schedule_dates[day][j].start_time != "" &&
    //               this.current_schedule_dates[day][j].end_time != ""
    //             ) {
    //               totalCurrentSlotSlots++;

    //               let currentSlotStartTimeSeconds = this.current_schedule_dates[
    //                 day
    //               ][j].start_time;
    //               let currentSlotEndTimeSeconds = this.current_schedule_dates[
    //                 day
    //               ][j].end_time;

    //               for (let i in userMergedSlots[day]) {
    //                 if (
    //                   currentSlotStartTimeSeconds >=
    //                     userMergedSlots[day][i].start_time &&
    //                   currentSlotStartTimeSeconds <=
    //                     userMergedSlots[day][i].end_time
    //                 ) {
    //                   validCurrentSlots++;
    //                   break;
    //                 }
    //               }
    //             }
    //           }
    //         }
    //         // console.log( totalCurrentSlotSlots);
    //         // console.log( validCurrentSlots );
    //         // console.log(this.ddd)
    //         // condition2 = totalCurrentSlotSlots == validCurrentSlots

    //         //// End Condition 2
    //         if (
    //           totalCurrentSlotSlots == validCurrentSlots &&
    //           this.ddd.length == 0 &&
    //           totalCurrentSlotSlots + validCurrentSlots !== 0
    //         ) {
    //            //
    //         } else {
    //           var without_cam_student = [];
    //           for (let i = 0; i < this.students.length; i++) {
    //             if (this.students[i].id == id) {
    //               this.students[i].cameras = "";
    //               without_cam_student.push(this.students[i]);
    //             }
    //           }
    //           // this.students=without_cam_student
    //         }
    //       }
    //     }
    //   }
    // },
    CheckCondtion1 (scheduleDates) {
      ////Condition1: Check if child days exist in parent
      //days of parent
      const parentScheduleDays = []

      for (const i in this.dataUserSchedule.schedule.scheduledates) {
        const element = this.dataUserSchedule.schedule.scheduledates[i]

        if (element['start_time'] != '' && element['end_time'] != '') {
          if (parentScheduleDays.indexOf(element['day']) == -1) {
            parentScheduleDays.push(element['day'])
          }
        }
      }

      //days of child
      const childScheduleDays = []

      for (const i in scheduleDates) {
        const element = scheduleDates[i]

        for (const j in element) {
          // console.log( "element" );
          // console.log( element[j] );

          if (element[j]['start_time'] != '' && element[j]['end_time'] != '') {
            if (childScheduleDays.indexOf(i) == -1) {
              childScheduleDays.push(i)
            }
          }
        }
      }

      // console.log(parentScheduleDays)
      // console.log(childScheduleDays)

      const condition1 =
        childScheduleDays.filter((d) => !parentScheduleDays.includes(d))
          .length == 0

      const ddd = childScheduleDays.filter(
        (d) => !parentScheduleDays.includes(d)
      )
      this.ddd = ddd
      // console.log( 'ddd' )
      // console.log( ddd )

      ////End Condition 1
    },
    MergeUserScheduleSlots (UserData) {
      // console.log("UserData=")
      // console.log(UserData)

      //Change location format into nested format

      //let UserData = this.dataLocation.scheduledates

      //Nested format will be assigned to this variable
      const currentFormatSchedule = []

      for (const i in UserData.schedule.scheduledates) {
        const day = UserData.schedule.scheduledates[i].day

        if (typeof currentFormatSchedule[day] === 'undefined') {
          currentFormatSchedule[day] = []
        }

        currentFormatSchedule[day].push({
          start_time: UserData.schedule.scheduledates[i].start_time,
          end_time: UserData.schedule.scheduledates[i].end_time,
          ID: UserData.schedule.scheduledates[i].ID
        })
      }

      // console.log("currentFormatSchedule=")
      // console.log( currentFormatSchedule )

      // console.log("currentFormatScheduleEND=")

      ////Merge Current Format Slots
      const current_schedule_dates = []

      for (const day in currentFormatSchedule) {
        let current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in currentFormatSchedule[day]) {
          if (
            currentFormatSchedule[day][j].start_time != '' &&
            currentFormatSchedule[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = currentFormatSchedule[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = currentFormatSchedule[day][
              j
            ].end_time.split(':')

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            for (
              let s = currentSlotStartTimeSeconds;
              s <= currentSlotEndTimeSeconds;
              s += 60
            ) {
              current_schedule_seconds_slots.push(s)
            }
          }
        }

        if (current_schedule_seconds_slots.length > 0) {
          current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function (a, b) {
            return a - b
          })

          // console.log(day)
          // console.log(current_schedule_seconds_slots)

          let startTime = current_schedule_seconds_slots[0]
          const endTime = ''
          // console.log(day)
          //  console.log(current_schedule_seconds_slots[0])
          for (const k in current_schedule_seconds_slots) {
            // console.log( current_schedule_seconds_slots[k] )
            // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

            if (
              typeof current_schedule_seconds_slots[parseInt(k) + 1] ===
                'undefined' ||
              current_schedule_seconds_slots[parseInt(k) + 1] -
                current_schedule_seconds_slots[k] !=
                60
            ) {
              if (startTime != current_schedule_seconds_slots[k]) {
                current_schedule_dates[day].push({
                  start_time: startTime,
                  end_time: current_schedule_seconds_slots[k]
                })

                if (
                  typeof current_schedule_seconds_slots[parseInt(k) + 1] !==
                  'undefined'
                ) {
                  startTime = current_schedule_seconds_slots[parseInt(k) + 1]
                }
              }
            }
          }

          //current_schedule_seconds_slots

          //console.log( current_schedule_seconds_slots )
        }
      }

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots

      return current_schedule_dates
    },
    MergeCurrentSlot (scheduleDates) {
      ////Merge Current Slots
      const current_schedule_dates = []
      for (const day in scheduleDates) {
        const current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in scheduleDates[day]) {
          if (
            scheduleDates[day][j].start_time != '' &&
            scheduleDates[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = scheduleDates[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = scheduleDates[day][j].end_time.split(
              ':'
            )

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            // for( let s = currentSlotStartTimeSeconds; s<= currentSlotEndTimeSeconds; s += 60 )
            // {
            //   current_schedule_seconds_slots.push( s )
            // }
            current_schedule_dates[day].push({
              start_time: currentSlotStartTimeSeconds,
              end_time: currentSlotEndTimeSeconds
            })
          }
        }
      }
      this.current_schedule_dates = current_schedule_dates

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots
    },
    SelectItem (id) {
      let status = false
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i] == id) {
          status = true
        }
      }
      if (status) {
        for (let i = 0; i < this.selected.length; i++) { 
          if (this.selected[i] === id) { 
            this.selected.splice(i, 1) 
          }
        }
      } else {
        this.selected.push(id)
      }
    },
    confStatus (status, id) {
      this.$apollo.mutate({
        mutation: UPDATE_STUDENT_STATUS,
        variables: {
          id,
          status
        }
      })
      this.acceptAlert()
    },
    setSelected (value) {
      this.custom_search_filter = value
    },
    cameraSelected (value) {
      this.custom_search_filter_camera = value
    },
    acceptAlert (status) {
      this.$vs.notify({
        color: 'success',
        title: 'Status Changed',
        position: 'top-right',
        text: 'Student Status Changed Successfully '
      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
    settingData (data) {
      this.sidebarSettingData = data
      this.toggleSettingSidebar(true)
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Student',
        text: 'Student Deleted Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    confirmDeleteRecord (student) {
      this.DeletedItem = student
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${student.fname} ${student.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    getCurrentPeriod () {
      const day = moment().format('dddd')
      const hr24 = moment(moment().format('LT'), ['h:mm A']).format('HH:mm')
      if (day == 'Monday') {
        this.currrent_schedule.dates.Monday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Tuesday') {
        this.currrent_schedule.dates.Tuesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Wednesday') {
        this.currrent_schedule.dates.Wednesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Thursday') {
        this.currrent_schedule.dates.Thursday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Friday') {
        this.currrent_schedule.dates.Friday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Saturady') {
        this.currrent_schedule.dates.Saturady.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Sunday') {
        this.currrent_schedule.dates.Sunday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
    },
    getUserSchedule (user) {
      const user_schedule = []
      if (user.schedule) {
        for (let j = 0; j < user.schedule.scheduledates.length; j++) {
          user_schedule.push(user.schedule.scheduledates[j])
        }
        this.dataUserSchedule.schedule.scheduledates = user_schedule
        this.CheckCondtion1(this.currrent_schedule.dates)
        this.MergeCurrentSlot(this.currrent_schedule.dates)
        const userMergedSlots = this.MergeUserScheduleSlots(
          this.dataUserSchedule
        )
        ////Condition 2: check each slot
        const condition2 = true
        let totalCurrentSlotSlots = 0
        let validCurrentSlots = 0
        for (const day in this.current_schedule_dates) {
          for (const j in this.current_schedule_dates[day]) {
            if (
              this.current_schedule_dates[day][j].start_time != '' &&
              this.current_schedule_dates[day][j].end_time != ''
            ) {
              totalCurrentSlotSlots++

              const currentSlotStartTimeSeconds = this.current_schedule_dates[
                day
              ][j].start_time
              const currentSlotEndTimeSeconds = this.current_schedule_dates[day][
                j
              ].end_time

              for (const i in userMergedSlots[day]) {
                if (
                  currentSlotStartTimeSeconds >=
                    userMergedSlots[day][i].start_time &&
                  currentSlotStartTimeSeconds <=
                    userMergedSlots[day][i].end_time
                ) {
                  validCurrentSlots++
                  break
                }
              }
            }
          }
        }
        // console.log(totalCurrentSlotSlots);
        // console.log(validCurrentSlots);
        // console.log(this.ddd)
        // condition2 = totalCurrentSlotSlots == validCurrentSlots

        //// End Condition 2
        if (
          totalCurrentSlotSlots == validCurrentSlots &&
          this.ddd.length == 0 &&
          totalCurrentSlotSlots + validCurrentSlots !== 0
        ) {
          //
        } else {
          const without_cam_student = []
          for (let i = 0; i < this.students.length; i++) {
            this.students[i].cameras = ''
            without_cam_student.push(this.students[i])
          }
          // this.students = without_cam_student;
        }
      }
    },
    conditionMethod (role, id) {
      if (role == 'user') {
        this.$apollo
          .mutate({
            mutation: GET_USER_STUDENTS,
            variables: {
              id
            }
          })
          .then((response) => {
            this.students = response.data.getUserStudents
            this.activeLoading = false
            this.$vs.loading.close()
            // this.getCurrentPeriod()
            // this.getUserSchedule(response.data.getUserStudents)
          })
      }  
    },
    get () {
       let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    const result = Math.random().toString(36).substring(2, 15)
    this.encrptId = 'getrhmw7zcbabcdefghijklmnTrst1234wxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz'

  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type: 'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  [data-letterstudent]:before {
    content: attr(data-letterstudent);
  }

  .studentdot {
    display: inline-block;
    font-size: 35px;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: -10px;
    margin-bottom: 5px;
  }

  .user_add_btn {
    float: right;
    margin-top: -50px;
  }

  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px;
    }
  }

  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
    .product-img {
      height: 70px;
      border-radius: 50%;
    }
  }
  #circle {
    background: lightblue;
    border-radius: 50%;
    width: 50px;
    height: 50px;
     text-align: center;
     margin: auto;
}
}
</style>